import React from "react";
import { Page } from "../../components/page/page";
import styles from "./crowd-comfort.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCrowdComfort } from "../../store/stateSlice";

const options = [
  {
    value: "Overwhelmed, the energy is too much",
    icon: "😨",
  },
  {
    value: "Comfortable, I enjoy the buzz",
    icon: "😊",
  },
  {
    value: "Indifferent, crowds don't affect me",
    icon: "🙅‍♀️",
  },
  {
    value: "Not sure",
    icon: "🤔",
  },
];

const CrowdComfortPage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="How do you feel in large crowds?"
      hideContinueButton={true}
      currentStep={4}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to="../feel-in-crowd"
              onClick={() => dispatch(setCrowdComfort(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { CrowdComfortPage };
